import React, { memo, useEffect, useState } from "react";
import { default as MaterialAvatar } from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

interface AvatarProps {
  userName: string;
  src: string;
  description?: string;
  className?: string;
  size?: "large" | "small" | "medium" | undefined;
}

const Avatar = ({ src, userName, className, size = "small" }: AvatarProps) => {
  const [imgSource, setImgSource] = useState<string>(src); //Motif Avatar is not handling on image load error

  useEffect(() => {
    if (src) {
      setImgSource(src);
    }
  }, [src]);

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    if (!name || typeof name !== "string" || name.trim().length === 0) {
      return {
        sx: { bgcolor: "#888" },
        children: "?"
      };
    }
    const parts = name.trim().split(" ");
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || "";
    return {
      sx: {
        bgcolor: stringToColor(name)
      },
      children: `${first}${second}` || first || "?"
    };
  }

  return (
    <Tooltip title={userName || "Unknown"} placement="top">
      <MaterialAvatar
        classes={className}
        alt={userName?.trim() || "?"}
        src={imgSource}
        sizes={size}
        {...stringAvatar(userName)}
      >
        {userName && userName.trim().length > 0
          ? userName
              .split(/\s/)
              .reduce((response, word) => (response += word.slice(0, 1)), "")
              .slice(0, 2)
          : "?"}
      </MaterialAvatar>
    </Tooltip>
  );
};
export default memo(Avatar);
